import React, { useState, useEffect } from 'react'

import {Grid} from '@mui/material'

import ComponentContainer from '../../core/template/ComponentContainer';
import {CoreContext} from "../../core/context/CoreContext";
import TaskinstanceEditForm from './TaskinstanceEditForm';
import TaskinstanceList from './TaskinstanceList';
import { useSelector, useDispatch } from 'react-redux';

import Notification from '../../core/components/Notification';

import TaskinstanceListView from './TaskinstanceListView'


export default function TaskinstanceDashboard(){
  const { setKeyValue, getKeyValues, keyvalues } = React.useContext(CoreContext);
  const {showEdit} = useSelector((state)=>state.manufslice.taskinstanceDashboard);
  const [ taskinstanceId, setTaskinstanceId] = React.useState('');
  const [reloadTaskinstanceList, setReloadTaskinstanceList] = useState(true);

  return (
      <>
      <Notification/>
      {showEdit?
        <ComponentContainer containedComponent = {
          <TaskinstanceEditForm 
            setReloadTaskinstanceList={setReloadTaskinstanceList}
            taskinstanceId={taskinstanceId}
            />}/>:
            <>
            <Grid container direction="column" >
              <Grid item>
                    {
                      <TaskinstanceListView 
                      setTaskinstanceId = {setTaskinstanceId}/>
                    }
              </Grid>
            </Grid>
            </>
      }
    </>


  )

}
